// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/icon/local.css
// module id = 300
// module chunks = 2